<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility" tabindex="-1" pplAutoFocusHeader>Authorization Utilization Analysis</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div style="width: 100%">
                    <ppl-accordion [title]="'Analyze Utilization'" [isOpen]="true">
                        <form nz-form nz-row [formGroup]="authAnalysisForm" class="ppl-p0 mt-2"
                            style="padding-left: 36px; padding-top: 16px;">
                            <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                                <nz-row>
                                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="participantPplId"
                                        class="ppl-form-label">Consumer PPL ID<span [attr.aria-label]="'Required'">*</span>
                                    </nz-form-label>
                                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                        <input nz-input formControlName="participantPplId" id="participantPplId"
                                            placeholder="Consumer PPL Id" (ngModelChange)="onConsumerChange($event)" />
                                        @if (authAnalysisForm.get('participantPplId')?.hasError('required') &&
                                        formSubmitted) {
                                        <span class="pl-1 error-message">Consumer PPL ID is required.</span>
                                        }
                                    </nz-form-control>
                                </nz-row>
                            </nz-form-item>
                            <!-- @if(showAdditionalFields){ -->
                            <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                                <nz-row>
                                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="dateOfService"
                                        class="ppl-form-label">Service
                                        Date<span [attr.aria-label]="'Required'">*</span>
                                    </nz-form-label>
                                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                        <nz-date-picker formControlName="dateOfService" [id]="'dateOfService'"
                                            style="height: 32px;" [nzFormat]="'MM/dd/yyyy'"
                                            [nzPlaceHolder]="'Service Date'"></nz-date-picker>
                                        @if (authAnalysisForm.get('dateOfService')?.hasError('required') &&
                                        formSubmitted) {
                                        <span class="pl-1 error-message">Service Date is required.</span>
                                        }
                                    </nz-form-control>
                                </nz-row>
                            </nz-form-item>
                            <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                                <nz-row>
                                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="hours" class="ppl-form-label">Service
                                        Duration<span [attr.aria-label]="'Required'">*</span>
                                    </nz-form-label>
                                    <nz-form-control [nzSm]="6" [nzXs]="24" class="ppl-form-control"
                                        style="padding-right: 8px;">
                                        <ppl-dropdown-select formControlName="hours" [placeholder]="'Hours'" class="ppl-select"
                                            [options]="hours" [optionLabel]="'label'" [optionValue]="'value'">
                                        </ppl-dropdown-select>
                                        @if (customTimeError) {
                                        <span class="pl-1 error-message">Please enter either hours or minutes.</span>
                                        }
                                    </nz-form-control>
                                    <nz-form-control [nzSm]="6" [nzXs]="24" class="ppl-form-control">
                                        <ppl-dropdown-select formControlName="minutes" [placeholder]="'Mins'" class="ppl-select"
                                        [options]="minutes" [optionLabel]="'label'" [optionValue]="'value'">
                                    </ppl-dropdown-select>
                                    </nz-form-control>
                                </nz-row>
                            </nz-form-item>
                            <nz-form-item nz-col nzSpan="24" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
                                <nz-row>
                                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="units" class="ppl-form-label">Units
                                    </nz-form-label>
                                    <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                        <input nz-input formControlName="units" id="units" />
                                    </nz-form-control>
                                </nz-row>
                            </nz-form-item>
                            <div class="custom-row" style="width: 100%;">
                                <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'"
                                    [iconPosition]="'right'" (click)="onCancel()"></ppl-button>
                                <ppl-button (click)="analyzeUtilization()" style="margin-right: 8px;" label="Analyze"
                                    icon="fa fa-check-circle" [customClass]="'primary-button'"
                                    [iconPosition]="'right'"></ppl-button>
                            </div>
                            <!-- } -->
                        </form>
                    </ppl-accordion>
                    @if(showResults){
                    <ppl-accordion [title]="'Analysis Results'" [isOpen]="true">
                        @if(analyzeResults.length > 0) {
                        <ppl-list-table [disableSearch]="true" [showCustomSearch]="false" [cols]="analyseCols"
                            [enableActions]="true" [data]="analyzeResultList" (rowDetailEvent)="rowClicked($event)"
                            [disableSelection]="true" [gridTitle]="false" [pagination]="true" [loadPage]="true"
                            (onPageLoad)="onPageLoad($event)" [customDataLoaded]="true" [from]="'billing'"
                            [enableActions]="false">
                        </ppl-list-table>
                        } @else {
                        <div class="alert alert-warning"><strong>No Records Found. </strong></div>
                        }
                    </ppl-accordion>

                    <ppl-accordion [title]="'Timesheets'" [isOpen]="true">
                        @if(analyzeResults.length > 0) {
                        <ppl-list-table [disableSearch]="true" [showCustomSearch]="false" [cols]="cols"
                            [enableActions]="true" [data]="analyzeResults" (rowDetailEvent)="rowClicked($event)"
                            (rowDetailEventTs)="rowActions($event)" [disableSelection]="true" [gridTitle]="false"
                            [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                            [customDataLoaded]="true" [from]="'billing'" [enableActions]="false">
                        </ppl-list-table>
                        } @else {
                        <div class="alert alert-warning"><strong>No Records Found. </strong></div>
                        }
                    </ppl-accordion>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>